module.exports = __webpack_public_path__ + "img/background_Image.38d2671e.png";